import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { PaperPlaneTilt, UploadSimple } from '@phosphor-icons/react';
import { sendEvent } from './utils/analytics';

const ContactInfo = () => {

  const baseTitle = 'Contact | Adam Ten'
  const description = 'Get in touch with Adam Ten team for bookings and management enquiries.';
  const currentUrl = 'https://www.adam-ten.com/contact';

  // Track modal open event with Google Analytics (only if consent is given)
  useEffect(() => {
    sendEvent({
      category: 'Modal',
      action: 'Opened Contact Modal',
      label: 'Contact Modal',
    });
  }, []);

  return (
    <div className="contact-modal max-width">

      <Helmet>
        <title>{baseTitle}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={baseTitle} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={baseTitle} />
        <meta name="twitter:description" content={description} />
        <link rel="canonical" href={currentUrl} />
        <meta property="og:url" content={currentUrl} />
      </Helmet>

      <h2>Contact</h2>
      <ul>
        <li>
          <div className="contact-item">
            <h3>Management</h3>
            <h4>James Drummond</h4>
            <div className="email">
              <span className="icon"><PaperPlaneTilt size={20} weight="bold" color="#ccc" /></span>
              <a href="mailto:jamesd@anglomanagement.co.uk" target="_blank" rel="noopener noreferrer">
                <span className="only-mobile">Email</span><span className="email-handle">jamesd@anglomanagement.co.uk</span>
              </a>
            </div>
          </div>
        </li>
        <li>
          <div className="contact-item">
            <h3>Booking</h3>
            <h4>North America &amp; Mexico</h4>
            <div className="email">
              <span className="icon"><PaperPlaneTilt size={20} weight="bold" color="#ccc" /></span>
              <a href="mailto:tal@strangetalent.agency" target="_blank" rel="noopener noreferrer">
                <span className="only-mobile">Strange Talent</span><span className="email-handle">tal@strangetalent.agency</span>
              </a>
            </div>
            <h4>Rest of World</h4>
            <div className="email">
              <span className="icon"><PaperPlaneTilt size={20} weight="bold" color="#ccc" /></span>
              <a href="mailto:sjh@wmeagency.com" target="_blank" rel="noopener noreferrer">
                <span className="only-mobile">WME Agency</span><span className="email-handle">sjh@wmeagency.com</span>
              </a>
            </div>
          </div>
        </li>
        <li>
          <div className="contact-item">
            <h3>Demos &amp; Promos</h3>
            <div className="email">
              <span className="icon"><UploadSimple size={20} weight="bold" color="#ccc" /></span>
              <a href="https://tstack.app/adamten" target="_blank" rel="noopener noreferrer">
                <span className="only-mobile">Send here</span><span className="email-handle">Send here</span>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ContactInfo;